import { Navigate, Route } from 'react-router-dom';
import { lazyPage } from './lazy';

// Each page is its own chunk, downloaded on first navigation (see routes/lazy.tsx).
const DashboardPage = lazyPage(
  () => import('@/features/personal/pages/DashboardPage'),
  'DashboardPage'
);
const ProfilePage = lazyPage(() => import('@/features/personal/pages/ProfilePage'), 'ProfilePage');
const CampusDrivesPage = lazyPage(
  () => import('@/features/personal/pages/CampusDrivesPage'),
  'CampusDrivesPage'
);
const CampusDriveDetailPage = lazyPage(
  () => import('@/features/personal/pages/CampusDriveDetailPage'),
  'CampusDriveDetailPage'
);
const OffersPage = lazyPage(() => import('@/features/personal/pages/OffersPage'), 'OffersPage');
const NoticesPage = lazyPage(() => import('@/features/personal/pages/NoticesPage'), 'NoticesPage');
const ProfileEditPage = lazyPage(
  () => import('@/features/personal/pages/ProfileEditPage'),
  'ProfileEditPage'
);
const ExperienceFormPage = lazyPage(
  () => import('@/features/personal/pages/ExperienceFormPage'),
  'ExperienceFormPage'
);
const EducationFormPage = lazyPage(
  () => import('@/features/personal/pages/EducationFormPage'),
  'EducationFormPage'
);
const ProjectFormPage = lazyPage(
  () => import('@/features/personal/pages/ProjectFormPage'),
  'ProjectFormPage'
);
const CertificationFormPage = lazyPage(
  () => import('@/features/personal/pages/CertificationFormPage'),
  'CertificationFormPage'
);
const SummaryFormPage = lazyPage(
  () => import('@/features/personal/pages/SummaryFormPage'),
  'SummaryFormPage'
);
const LanguagesFormPage = lazyPage(
  () => import('@/features/personal/pages/LanguagesFormPage'),
  'LanguagesFormPage'
);
const SkillsAndAssessmentsPage = lazyPage(
  () => import('@/features/personal/pages/SkillsAndAssessmentsPage'),
  'SkillsAndAssessmentsPage'
);
const SkillsManagePage = lazyPage(
  () => import('@/features/personal/pages/SkillsManagePage'),
  'SkillsManagePage'
);
const AssessmentsBrowsePage = lazyPage(
  () => import('@/features/personal/pages/AssessmentsBrowsePage'),
  'AssessmentsBrowsePage'
);
const AssessmentDetailPage = lazyPage(
  () => import('@/features/personal/pages/AssessmentDetailPage'),
  'AssessmentDetailPage'
);
const AssessmentAttemptPage = lazyPage(
  () => import('@/features/personal/pages/AssessmentAttemptPage'),
  'AssessmentAttemptPage'
);
const ResumeReviewsPage = lazyPage(
  () => import('@/features/personal/pages/ResumeReviewsPage'),
  'ResumeReviewsPage'
);
const ResumesPage = lazyPage(
  () => import('@/features/personal/resume-builder/hub/ResumeHubPage'),
  'ResumeHubPage'
);
const ResumeCreatePage = lazyPage(
  () => import('@/features/personal/resume-builder/hub/CreatePage'),
  'CreatePage'
);
const ResumeWizardPage = lazyPage(
  () => import('@/features/personal/resume-builder/hub/WizardPage'),
  'WizardPage'
);
const ResumeBuilderPage = lazyPage(
  () => import('@/features/personal/resume-builder/ResumeBuilderPage'),
  'ResumeBuilderPage'
);
const CoverLettersPage = lazyPage(
  () => import('@/features/personal/pages/CoverLettersPage'),
  'CoverLettersPage'
);
const CoverLetterCreatePage = lazyPage(
  () => import('@/features/personal/pages/CoverLetterCreatePage'),
  'CoverLetterCreatePage'
);
const CoverLetterBuilderPage = lazyPage(
  () => import('@/features/personal/pages/CoverLetterBuilderPage'),
  'CoverLetterBuilderPage'
);
const JobsPage = lazyPage(() => import('@/features/personal/pages/JobsPage'), 'JobsPage');
const JobApplyPage = lazyPage(
  () => import('@/features/personal/pages/JobApplyPage'),
  'JobApplyPage'
);
const MessagesPage = lazyPage(
  () => import('@/features/personal/pages/MessagesPage'),
  'PersonalMessagesPage'
);
const ConnectHubPage = lazyPage(
  () => import('@/features/personal/pages/ConnectHubPage'),
  'ConnectHubPage'
);
const PersonProfilePage = lazyPage(
  () => import('@/features/personal/pages/PersonProfilePage'),
  'PersonProfilePage'
);
const InsightsPage = lazyPage(
  () => import('@/features/personal/pages/InsightsPage'),
  'InsightsPage'
);
const SettingsPage = lazyPage(
  () => import('@/features/personal/pages/SettingsPage'),
  'SettingsPage'
);
const PrivacyPage = lazyPage(() => import('@/features/personal/pages/PrivacyPage'), 'PrivacyPage');
const BillingPage = lazyPage(() => import('@/features/personal/pages/BillingPage'), 'BillingPage');
const PricingPage = lazyPage(() => import('@/features/personal/pages/PricingPage'), 'PricingPage');
const CheckoutSuccessPage = lazyPage(
  () => import('@/features/personal/pages/CheckoutSuccessPage'),
  'CheckoutSuccessPage'
);
const StoragePage = lazyPage(() => import('@/features/personal/pages/StoragePage'), 'StoragePage');
const DocumentsPage = lazyPage(
  () => import('@/features/personal/pages/DocumentsPage'),
  'DocumentsPage'
);
const CreateOrganizationPage = lazyPage(
  () => import('@/features/personal/pages/CreateOrganizationPage'),
  'CreateOrganizationPage'
);
const FindCollegePage = lazyPage(
  () => import('@/features/personal/pages/FindCollegePage'),
  'FindCollegePage'
);
const MergeAccountsPage = lazyPage(
  () => import('@/features/personal/pages/MergeAccountsPage'),
  'MergeAccountsPage'
);
const MyCollegePage = lazyPage(
  () => import('@/features/personal/pages/MyCollegePage'),
  'MyCollegePage'
);
const ApplicationsPage = lazyPage(
  () => import('@/features/personal/pages/ApplicationsPage'),
  'ApplicationsPage'
);

export const PersonalRoutes = () => (
  <>
    {/* Dashboard */}
    <Route path="/personal/dashboard" element={<DashboardPage />} />

    {/* Profile */}
    <Route path="/personal/profile" element={<ProfilePage />} />
    <Route path="/personal/profile/edit" element={<ProfileEditPage />} />
    <Route path="/personal/profile/experience/new" element={<ExperienceFormPage />} />
    <Route path="/personal/profile/experience/:id/edit" element={<ExperienceFormPage />} />
    <Route path="/personal/profile/education/new" element={<EducationFormPage />} />
    <Route path="/personal/profile/education/:id/edit" element={<EducationFormPage />} />
    <Route path="/personal/profile/projects/new" element={<ProjectFormPage />} />
    <Route path="/personal/profile/projects/:id/edit" element={<ProjectFormPage />} />
    <Route path="/personal/profile/certifications/new" element={<CertificationFormPage />} />
    <Route path="/personal/profile/certifications/:id/edit" element={<CertificationFormPage />} />
    <Route path="/personal/profile/summary/edit" element={<SummaryFormPage />} />
    <Route path="/personal/profile/languages/edit" element={<LanguagesFormPage />} />
    <Route path="/personal/profile/skills" element={<SkillsManagePage />} />
    <Route
      path="/personal/profile/skills/new"
      element={<Navigate to="/personal/profile/skills" replace />}
    />
    <Route
      path="/personal/profile/skills/:groupKey/edit"
      element={<Navigate to="/personal/profile/skills" replace />}
    />
    <Route path="/personal/skills-and-assessments" element={<SkillsAndAssessmentsPage />} />

    {/* Resume */}
    <Route path="/personal/resume" element={<ResumesPage />} />
    <Route path="/personal/resume/reviews" element={<ResumeReviewsPage />} />
    <Route path="/personal/resume/create" element={<ResumeCreatePage />} />
    <Route path="/personal/resume/wizard" element={<ResumeWizardPage />} />
    <Route path="/personal/resume/builder" element={<ResumeBuilderPage />} />
    <Route path="/personal/resume/builder/:id" element={<ResumeBuilderPage />} />

    {/* Cover Letters */}
    <Route path="/personal/cover-letters" element={<CoverLettersPage />} />
    <Route path="/personal/cover-letters/create" element={<CoverLetterCreatePage />} />
    <Route path="/personal/cover-letters/builder" element={<CoverLetterBuilderPage />} />
    <Route path="/personal/cover-letters/builder/:id" element={<CoverLetterBuilderPage />} />

    {/* Jobs */}
    <Route path="/personal/jobs" element={<JobsPage />} />
    <Route path="/personal/jobs/:jobId/apply" element={<JobApplyPage />} />
    <Route path="/personal/applications" element={<ApplicationsPage />} />
    <Route path="/personal/drives" element={<CampusDrivesPage />} />
    <Route path="/personal/drives/:driveId" element={<CampusDriveDetailPage />} />
    <Route path="/personal/offers" element={<OffersPage />} />
    <Route path="/personal/notices" element={<NoticesPage />} />

    {/* Documents */}
    <Route path="/personal/documents" element={<DocumentsPage />} />

    {/* Messages */}
    <Route path="/personal/messages" element={<MessagesPage />} />

    {/* ConnectHub (connections) — path kept stable: notifications deep-link here */}
    <Route path="/personal/connections" element={<ConnectHubPage />} />
    {/* In-app member profile — /u/:profileId stays the outward-facing portfolio */}
    <Route path="/personal/people/:profileId" element={<PersonProfilePage />} />

    {/* Insights — sub-routes redirect to main insights page */}
    <Route path="/personal/insights" element={<InsightsPage />} />
    <Route
      path="/personal/insights/resume-readiness"
      element={<Navigate to="/personal/insights" replace />}
    />
    <Route
      path="/personal/insights/job-match"
      element={<Navigate to="/personal/insights" replace />}
    />
    <Route
      path="/personal/insights/skill-gap"
      element={<Navigate to="/personal/insights" replace />}
    />
    <Route
      path="/personal/insights/recommendations"
      element={<Navigate to="/personal/insights" replace />}
    />

    {/* Assessments */}
    <Route path="/personal/assessments/browse" element={<AssessmentsBrowsePage />} />
    <Route path="/personal/assessments/attempts/:attemptId" element={<AssessmentAttemptPage />} />
    <Route path="/personal/assessments/:id" element={<AssessmentDetailPage />} />

    {/* Settings */}
    <Route path="/personal/settings" element={<SettingsPage />} />
    <Route path="/personal/subscription-and-billing" element={<BillingPage />} />
    <Route path="/personal/pricing" element={<PricingPage />} />
    <Route path="/personal/checkout/success" element={<CheckoutSuccessPage />} />
    <Route path="/personal/settings/storage" element={<StoragePage />} />
    <Route path="/personal/settings/merge-accounts" element={<MergeAccountsPage />} />
    <Route
      path="/personal/settings/preferences"
      element={<Navigate to="/personal/settings" replace />}
    />
    <Route path="/personal/settings/privacy" element={<PrivacyPage />} />
    <Route
      path="/personal/settings/notifications"
      element={<Navigate to="/personal/settings?tab=notifications" replace />}
    />
    <Route
      path="/personal/settings/connected"
      element={<Navigate to="/personal/settings" replace />}
    />
    <Route
      path="/personal/settings/data-export"
      element={<Navigate to="/personal/settings/privacy" replace />}
    />

    {/* Organization creation */}
    <Route path="/organization/create" element={<CreateOrganizationPage />} />

    {/* A student's college home, and finding a college to join */}
    <Route path="/personal/my-college" element={<MyCollegePage />} />
    <Route path="/personal/find-college" element={<FindCollegePage />} />
  </>
);
